import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kys-aml-checks',
  templateUrl: './kys-aml-checks.component.html',
  styleUrls: ['./kys-aml-checks.component.scss']
})
export class KysAMLChecksComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  openModal(){
    const buttonModal = document.getElementById("openModalButton")
    console.log('buttonModal', buttonModal)
    buttonModal.click()
  }

}
